import { useState, useEffect } from 'react';

import MainHeader from '../../components/main-header/main-header.component';
import MainMultiDisplay from '../../components/main-multi-display/main-multi-display.component';
import SectionsScroll from '../../components/sections-scroll/sections-scroll.component';

import { SectionBoxContainer } from './section-box.styles';


const SectionBox = ({section}) => {
    const [ selected, setSelected ] = useState(0);
    const [ displayed, setDisplayed ] = useState(0);

    const sectionClick = (i) => {
        setSelected(i);
    }

    return (
        <SectionBoxContainer>
            <MainHeader 
                text1="E-commerce failure rate is 90%."
                text2="No worries, they didn't find us.. but you did." />
            <SectionsScroll 
                displays={section} 
                selected={selected} 
                sectionClick={sectionClick} 
            />
            <MainMultiDisplay displays={section[selected].services} />
        </SectionBoxContainer>
    )
}

export default SectionBox;